import styled from 'styled-components';

export const FormItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const FormLabel = styled.div`
    color: #000;
    display: flex;
    gap: 4px;
    align-items: center;
    font-weight: 600;
    margin-left: 8px;
`;